/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Scope_PersonalInputs */

const en_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const fr_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const de_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const it_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const ru_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const es_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const zh_cn2_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const ja_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const hi_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const pt_pt2_explorer_search_scope_personal = /** @type {(inputs: Explorer_Search_Scope_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

/**
* | output |
* | --- |
* | "Personal" |
*
* @param {Explorer_Search_Scope_PersonalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_scope_personal = /** @type {((inputs?: Explorer_Search_Scope_PersonalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Scope_PersonalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_scope_personal(inputs)
	if (locale === "de") return de_explorer_search_scope_personal(inputs)
	if (locale === "it") return it_explorer_search_scope_personal(inputs)
	if (locale === "ru") return ru_explorer_search_scope_personal(inputs)
	if (locale === "es") return es_explorer_search_scope_personal(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_scope_personal(inputs)
	if (locale === "ja") return ja_explorer_search_scope_personal(inputs)
	if (locale === "hi") return hi_explorer_search_scope_personal(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_scope_personal(inputs)
	return en_explorer_search_scope_personal(inputs)
});